import React from 'react';

const styles = {
  primary:
    'rounded-full px-5 py-2.5 text-sm font-semibold bg-[#C8A75B] text-gray-900 hover:brightness-95 transition-colors',
  outline:
    'rounded-full px-5 py-2.5 text-sm font-semibold border border-[#C8A75B] text-[#C8A75B] bg-white hover:bg-[#C8A75B]/10 transition-colors',
  dark:
    'rounded-full px-5 py-2.5 text-sm font-semibold bg-black text-white hover:bg-gray-800 transition-colors',
  ghost:
    'rounded-full px-4 py-2 text-sm font-medium text-gray-700 hover:bg-white transition-colors',
  text:
    'text-sm font-semibold text-gray-900 hover:text-[#C8A75B] transition-colors',
};

export default function Button({ variant = 'primary', className = '', ...props }) {
  const base = styles[variant] || styles.primary;
  return <button className={`${base} ${className}`.trim()} {...props} />;
}

